const INVITE_V3_INVITER_DATA = 'jerry-v3-invitee-data';
const SPLIT = ',';

export interface InviteV3Data {
  inviterCode: string;
  inviterName: string;
  joinConnectionSuccess?: boolean;
  joinConnectionMsg?: string;
}

/**
 * Save invite v3 data to cookie
 */
export const saveInviteV3Data = (inviteData: InviteV3Data): void => {
  if (typeof document === 'undefined') {
    return;
  }
  const msg = (inviteData.joinConnectionMsg || '').split(';').join(SPLIT);
  document.cookie = `${INVITE_V3_INVITER_DATA}=${inviteData.inviterCode}${SPLIT}${inviteData.inviterName}${SPLIT}${inviteData.joinConnectionSuccess}${SPLIT}${msg}`;
};

/**
 * Get invite v3 data from cookie
 */
export const getInviteV3Data = (cookie: Record<string, unknown>): InviteV3Data | undefined => {
  const inviteData = cookie?.[INVITE_V3_INVITER_DATA];
  if (!inviteData) {
    return undefined;
  }
  const [inviterCode, inviterName, successStr, ...joinConnectionMsgSegs] = (inviteData as string).split(SPLIT);
  if (!inviterName || !inviterCode) {
    return undefined;
  }
  return {
    inviterCode,
    inviterName,
    joinConnectionSuccess: successStr === 'true',
    joinConnectionMsg: joinConnectionMsgSegs.join(SPLIT),
  } as InviteV3Data;
};
